import { userAllowedThroughFeatureFlag } from './validation/userAllowedFeatureFlag';

//Routes
export const TASKS_ROUTE = 'tasks';
export const TIME_ROUTE = 'time';
export const TIME_APP_ROUTE = 'time-reg';
export const TIME_ADD_APP_ROUTE = 'timereg-add';
export const GOODS_ROUTE = 'goods';
export const ORDER_GOODS_ROUTE = 'goods-order';
export const MOVE_GOODS_ROUTE = 'goods-move';
export const RETURN_GOODS_ROUTE = 'return';
export const RETURN_RECEIPT_ROUTE = 'return-receipt';
export const ORDER_RECEIPT_ROUTE = 'order-receipt';
export const TECHNICIANDUTY_ROUTE = 'vagt';
export const TASKS_DETAILS = 'task-details';
export const WORKPLAN_ROUTE = 'workplan';
export const CALENDAR_ROUTE = 'calendar';
export const TECHNICIAN_TASKLIST_ROUTE = 'tasks-technician';
export const PORTAL_ROUTE = 'portal';
export const SCANNER = 'scanner';
export const INTERNAL_TIME_OFFICE = 'internal-office';
export const ADMIN_NEWS = 'admin/news';
export const ADMIN_DEPARTMENTS = 'admin/departments';
export const ADMIN_TASKTYPES = 'admin/tasktypes';
export const ADMIN_REUSABLECOMPONENTS = 'admin/reusable-components';
export const ADMIN_PORTAL_LINKS = 'admin/portal-links';
export const ADMIN_REASONCODES = 'admin/reason-codes';
export const ADMIN_QUESTIONS = 'admin/questions';
export const ADMIN_UPDATE_TASK_STATUS = 'admin/update-task-status';
export const DEV_INBOX = 'dev/inbox';
export const DEV_OUTBOX = 'dev/outbox';
export const MAP_TASK_LIST_ROUTE = 'map';
export const SCHEDULE_ROUTE = 'schedule';
export const COUNT_GOODS_ROUTE = 'count-goods';
export const IMAGE_ROUTE = 'image';
export const NEWS_ROUTE = 'news';

// Dialogs
export const ADD_TIME_ROUTE = '/add-timereg';
export const EDIT_TASK_ROUTE = '/edit-task';
export const TASKS_DETAILS_DIALOG_ROUTE = '/task-details-dialog';
export const MASS_CREATION = '/mass-creation';
export const PROFILE_ROUTE = '/profile';

//DepartmentId
export const PLANNING_DEPARTMENT_ID = 17;
export const CONTROL_ROOM_DEPARTMENT_ID = 6;
// The department a work permit is moved to when it is sent back to the technician, until the technician
// sends it to Kontrolrummet. It is set per environment
export const getWorkPermitTechnicianDepartmentId = () =>
  parseInt(window._env_.WORK_PERMIT_TECHNICIAN_DEPARTMENT_ID);
// The work permit (Arbejdstilladelse (KOS)) task type. NaN when KOS is turned off by FeatureFlags_KOS or no task
// type is set for the environment, which hides every KOS tab, step, button and warning
export const getWorkPermitTaskTypeId = () =>
  userAllowedThroughFeatureFlag(window._env_.FeatureFlags_KOS) ? parseInt(window._env_.WORK_PERMIT_TASK_TYPE_ID) : NaN;

//D365 related constants
// Fallback goods legal entity, only used when no warehouse has been loaded.
// The active one (110 or 611) is set by GOODS_LEGAL_ENTITY_ID in WarehouseAPI and arrives on every WarehouseDTO.
export const D365_LEGALENTITYID_FOR_PRODUCTS = '611';

//Error codes
export enum ErrorCodes {
  ERP_CALL_ERROR = 'ERP_CALL_ERROR',
  PROJECT_VALIDATION_ERROR = 'PROJECT_VALIDATION_ERROR'
}
